module.exports = __webpack_public_path__ + "bg.svg?494aa5696f310b06328d4768c4bacdcc";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/bg.svg
// module id = 997
// module chunks = 0